module.exports = __webpack_public_path__ + "img/instagram.3c451c27.svg";